import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../utils/translations';
import {ALERT_WARNING__32} from '@homeaway/svg-defs/lib/defs/ALERT_WARNING__32';
import {CHECK__24} from '@homeaway/svg-defs/lib/defs/CHECK__24';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';

import './CancelTripModalConfirmation.less';

export class CancelTripModalConfirmation extends Component {
    static propTypes = {
        hasError: PropTypes.bool,
        labels: PropTypes.shape({
            done: PropTypes.string,
        }),
        onClose: PropTypes.func,
        title: PropTypes.string,
        text: PropTypes.string,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        translations: {},
    };

    render() {
        const {hasError, translations} = this.props;

        return (
            <div className="CancelTrip__step text-center">
                {hasError ? (
                    <SVGIcon
                        className="CancelTrip__error-icon text-danger"
                        markup={ALERT_WARNING__32}
                    />
                ) : (
                    <SVGIcon
                        className="CancelTrip__success-icon text-brand"
                        markup={CHECK__24}
                    />
                )}
                <h3 className="CancelTrip__title">{this.props.title}</h3>
                <p className="CancelTrip__text">{this.props.text}</p>
                {hasError ? null : (
                    <ButtonPrimary
                        label={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.button.done'
                        )}
                        onClick={this.props.onClose}
                    />
                )}
            </div>
        );
    }
}
